import { CarrierCode } from '#app/typings/carrier';
import { Channel } from '#app/typings/channel';

export enum OrderClientState {
  CART = 1,
  CONFIRMED = 2,
  IN_PREPARATION = 3,
  PACKAGING = 4,
  IN_TRANSIT = 5,
  COMPLETED = 6,
  DISPUTED = 7,
  ABANDONED_CART = 8,
  OUT_OF_STOCK = 9,
  CANCELED = 10,
}

export const OrderClientStateTranslation: Record<OrderClientState, string> = {
  [OrderClientState.CART]: 'Panier',
  [OrderClientState.CONFIRMED]: 'Confirmée',
  [OrderClientState.IN_PREPARATION]: 'En préparation',
  [OrderClientState.PACKAGING]: 'Colisage',
  [OrderClientState.IN_TRANSIT]: 'En transit',
  [OrderClientState.COMPLETED]: 'Terminée',
  [OrderClientState.DISPUTED]: 'En litige',
  [OrderClientState.ABANDONED_CART]: 'Abandon panier',
  [OrderClientState.OUT_OF_STOCK]: 'Rupture',
  [OrderClientState.CANCELED]: 'Annulée',
};

export const OrderClientStateSelects = (Object.keys(OrderClientStateTranslation) as unknown as OrderClientState[]).map(
  (orderClientState) => ({
    value: orderClientState,
    label: OrderClientStateTranslation[orderClientState],
  }),
);

export type OrderClientList = {
  createdAt: string;
  uuid: string;
  number?: string;
  numberSylius?: string;
  client?: {
    email: string;
    name: string;
  };
  channel: Channel;
  orderClientState: OrderClientState;
  orderClientCarrier: {
    label: string;
  };
  confirmedAt?: string;
  guest: boolean;
};

export type OrderClientListByClient = {
  createdAt: string;
  uuid: string;
  number?: string;
  numberSylius?: string;
  numberCarrier?: string;
  channel: Channel;
  orderClientState: OrderClientState;
  orderClientCarrier: {
    label: string;
  };
  orderClientPromotions?: {
    coupon: string;
  }[];
  orderClientLitiges: any[];
  guest: boolean;
  priceTTC: number;
};

export type OrderClientUserManager = {
  channel: Channel;
  client: {
    email: string;
  };
  orderClientCarrier: {
    carrier: {
      code: CarrierCode;
    };
  };
  confirmedAt: string;
  number: string;
  orderClientState: OrderClientState;
};

export type ShopPayment = {
  number: string;
  confirmedAt: { date: string };
  name: string;
  shopCard: number;
  shopCash: number;
  shopAvoir: number;
  cashBack: number;
  htOrder: number;
  ttcOrder: number;
};
